<h2 mat-dialog-title >Multiple collections detected</h2>

<mat-dialog-content >
    <div>The shape you have drawn spans two or more different collections. Please edit the shape so that all the vertices are included in one single collection.</div>
</mat-dialog-content>
<mat-dialog-actions >
    <button matButton="elevated" mat-dialog-close (click)="closeDialog()" >Ok</button>
</mat-dialog-actions>